module.exports = __webpack_public_path__ + "b4f32446860bfc853d05e2c93223175e.svg";